import type { MotionValue } from 'framer-motion'

export function measureCenter(
  node: SVGSVGElement | null,
  centerX: MotionValue<number>,
  centerY: MotionValue<number>,
) {
  if (!node) {
    return
  }
  let frame = 0
  const measure = () => {
    const rect = node.getBoundingClientRect()
    centerX.set(rect.left + rect.width / 2)
    centerY.set(rect.top + rect.height / 2)
  }
  measure()
  const observer = new ResizeObserver(measure)
  observer.observe(node)
  const onScroll = () => {
    if (frame !== 0) {
      return
    }
    frame = window.requestAnimationFrame(() => {
      frame = 0
      measure()
    })
  }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true })
  window.addEventListener('pointerup', measure)
  return () => {
    observer.disconnect()
    window.removeEventListener('scroll', onScroll, true)
    window.removeEventListener('pointerup', measure)
    if (frame !== 0) {
      window.cancelAnimationFrame(frame)
    }
  }
}
